var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createDemoPeriodComparisonMatcher } from '@web/lib/demo/utils';
import { calculateAverage, getInterval, getPercentageDiff, getPreviousPeriod, groupByPeriod } from '@workalizer/shared/utils';
import { endOfDay, startOfDay } from 'date-fns';
var mockPeriodData = [
    { accepted: 2, rejected: 1 },
    { accepted: 3, rejected: 0 },
    { accepted: 1, rejected: 2 },
    { accepted: 4, rejected: 1 },
    { accepted: 2, rejected: 3 },
    { accepted: 3, rejected: 1 },
    { accepted: 1, rejected: 2 }
];
var mockPrevPeriodData = [
    { accepted: 1, rejected: 2 },
    { accepted: 2, rejected: 1 },
    { accepted: 3, rejected: 0 },
    { accepted: 1, rejected: 3 },
    { accepted: 2, rejected: 1 },
    { accepted: 1, rejected: 2 },
    { accepted: 2, rejected: 1 }
];
var mockTeamPeriodData = [
    { accepted: 4, rejected: 2 },
    { accepted: 5, rejected: 1 },
    { accepted: 3, rejected: 3 },
    { accepted: 6, rejected: 2 },
    { accepted: 4, rejected: 4 },
    { accepted: 5, rejected: 2 },
    { accepted: 3, rejected: 3 }
];
export var docReviewCount = function (input) {
    var interval = getInterval(input.dateFrom, input.dateTo);
    var dateFrom = startOfDay(input.dateFrom);
    var dateTo = endOfDay(input.dateTo);
    var _a = getPreviousPeriod(input.dateFrom, input.dateTo), prevPeriodDateFrom = _a.prevPeriodDateFrom, prevPeriodDateTo = _a.prevPeriodDateTo;
    var periods = groupByPeriod([], dateFrom, dateTo, interval);
    var previousPeriods = groupByPeriod([], startOfDay(prevPeriodDateFrom), endOfDay(prevPeriodDateTo), interval);
    var periodMatcher = createDemoPeriodComparisonMatcher(input, interval, periods, previousPeriods);
    var mockPeriodsData = periods.map(function (period, idx) {
        var _a;
        var currentData = mockPeriodData[idx % mockPeriodData.length];
        var prevPeriod = periodMatcher.getItem(idx, previousPeriods);
        var previousIndex = prevPeriod
            ? previousPeriods.indexOf(prevPeriod)
            : null;
        var prevData = mockPrevPeriodData[(previousIndex !== null && previousIndex !== void 0 ? previousIndex : idx) % mockPrevPeriodData.length];
        return __assign({ period: period.date, previousPeriodLabel: (_a = prevPeriod === null || prevPeriod === void 0 ? void 0 : prevPeriod.date) !== null && _a !== void 0 ? _a : '', accepted: currentData.accepted, rejected: currentData.rejected, prevAccepted: prevData.accepted, prevRejected: prevData.rejected }, (input.userId && {
            teamAccepted: mockTeamPeriodData[idx % mockTeamPeriodData.length].accepted,
            teamRejected: mockTeamPeriodData[idx % mockTeamPeriodData.length].rejected
        }));
    });
    var currentAcceptedCount = mockPeriodData.reduce(function (sum, item) { return sum + item.accepted; }, 0);
    var currentRejectedCount = mockPeriodData.reduce(function (sum, item) { return sum + item.rejected; }, 0);
    var previousAcceptedCount = mockPrevPeriodData.reduce(function (sum, item) { return sum + item.accepted; }, 0);
    var previousRejectedCount = mockPrevPeriodData.reduce(function (sum, item) { return sum + item.rejected; }, 0);
    var teamAcceptedCount = 25;
    var teamRejectedCount = 15;
    var teamUserCount = 8;
    return {
        periods: mockPeriodsData,
        totals: {
            accepted: __assign({ current: currentAcceptedCount, previous: getPercentageDiff(previousAcceptedCount, currentAcceptedCount) }, (input.userId && {
                teamAverage: getPercentageDiff(calculateAverage(teamAcceptedCount, teamUserCount), currentAcceptedCount)
            })),
            rejected: __assign({ current: currentRejectedCount, previous: getPercentageDiff(previousRejectedCount, currentRejectedCount) }, (input.userId && {
                teamAverage: getPercentageDiff(calculateAverage(teamRejectedCount, teamUserCount), currentRejectedCount)
            }))
        }
    };
};
